export default "__VITE_ASSET__DIMrld8A__"